function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { AddButton, Button } from '../util/buttons';
import CompanyUserItem from './CompanyUserItem';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '../util';
import companyUsersService from '../services/company_user.service';
import { handleError } from '../store/features/alertSlice';
import { useDispatch } from 'react-redux';
export default function AddUserToCompany(_ref) {
  let {
    user,
    setUser,
    companies
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedCompany, setSelectedCompany] = useState({});
  const dispatch = useDispatch();
  const removeCompanyFromUser = async index => {
    if (user.id && user.company_users[index].id) {
      const id = user.company_users[index].id;
      try {
        const companyUsers = user.company_users;
        const newCompanyUsers = companyUsers.filter(companyUser => companyUser.id !== id);
        await companyUsersService.delete(user.id, id);
        setUser(_objectSpread(_objectSpread({}, user), {}, {
          company_users: newCompanyUsers,
          company_users_attributes: newCompanyUsers
        }));
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newCompanyUsers = user.company_users;
      newCompanyUsers.splice(index, 1);
      setUser(_objectSpread(_objectSpread({}, user), {}, {
        company_users: newCompanyUsers,
        company_users_attributes: newCompanyUsers
      }));
    }
  };
  const addCompanyToUser = company => {
    const companyUsers = user.company_users;
    companyUsers.push({
      company: {
        name: company.name,
        id: company.id
      },
      company_id: company.id
    });
    setUser(_objectSpread(_objectSpread({}, user), {}, {
      company_users: companyUsers,
      company_users_attributes: companyUsers
    }));
  };
  const changeSelectedCompany = companyId => {
    const currentCompany = companies.find(company => company.id == companyId);
    setSelectedCompany(currentCompany || {});
  };
  const remainingCompaniesOptionsToAdd = companies.filter(company => user.company_users.every(cu => cu.company_id !== company.id)).map(company => ({
    key: company.id,
    value: company.id,
    text: company.name
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: 3
  }, t('companies')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Dropdown, {
    options: remainingCompaniesOptionsToAdd,
    onChange: changeSelectedCompany
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(AddButton, {
    variant: "link",
    disabled: !selectedCompany,
    onClick: () => {
      addCompanyToUser(selectedCompany);
      setSelectedCompany({});
    }
  }))), user.company_users.map((uc, index) => {
    return /*#__PURE__*/React.createElement(CompanyUserItem, {
      companyUser: uc,
      handleDelete: removeCompanyFromUser,
      key: index,
      index: index
    });
  }));
}